
jQuery(document).ready(function($){

    //css support
    $('ul.col-2 li:nth-child(2n+2),ul.col-3 li:nth-child(3n+3),ul.col-4 li:nth-child(4n+4),ul.col-5 li:nth-child(5n+5),ul.col-6 li:nth-child(6n+6),ul.col-7 li:nth-child(7n+7)').css('margin-right','0');
    // your code
});

$(function(){
    var win_h=$(window).height();
    $(".popup_bj").css("height",win_h);
});





//////////////////
// WEBPACK FOOTER
// ./static/js/public.js
// module id = nwBL
// module chunks = 1